// @flow

export const MAX_AVATARS_SHOWN = 3;
export type ProfileBoardCardLayout = 'square' | 'wide' | 'xWide' | 'xxWide';

const LAYOUT_SIZES = {
  square: { width: 236, height: 236 },
  wide: { width: 300, height: 200 },
  xWide: { width: 358, height: 200 },
  xxWide: { width: 376, height: 200 },
};

const INVITE_LAYOUT_SIZES = {
  square: { width: 236, height: 176 },
  wide: { width: 300, height: 135 },
  xWide: { width: 358, height: 200 },
  xxWide: { width: 376, height: 200 },
};

export function getCardWidth(layout: ProfileBoardCardLayout, isInvite: ?boolean) {
  if (isInvite) {
    return INVITE_LAYOUT_SIZES[layout].width;
  }
  return LAYOUT_SIZES[layout].width;
}

export function getCardHeight(layout: ProfileBoardCardLayout, isInvite: ?boolean) {
  if (isInvite) {
    return INVITE_LAYOUT_SIZES[layout].height;
  }
  return LAYOUT_SIZES[layout].height;
}
